import get from 'lodash/get';

export const selectShowModal = (state) => get(state, 'settings.showModal', false);

export const selectTemplates = (state) => {
  const templates = get(state, 'settings.ticketingTools.templates', []);
  return templates.map((x) => ({ desc: x, name: x }));
};
